import insightsData from '@/data/insights.json'

export type InsightArticle = (typeof insightsData.articles)[number]

/** The article whose film leads News. */
export const filmArticle = insightsData.articles.find((article) => article.film)

/** A category's display name, from its slug. */
export const categoryName = (slug: string) => insightsData.categories.find((category) => category.slug === slug)?.name ?? slug

export const formatArticleDate = (date: string) =>
  new Date(date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })

/** Minutes to read at about 200 words a minute, at least one. */
export const readingMinutes = (content: string) => Math.max(1, Math.ceil(content.split(/\s+/).length / 200))
